import UserInfoCell from "../../../../../../../components/userInfoCell/UserInfoCell";
import { type ColumnOption } from "../../../../../../../interfaces/columnOptions";
import { type PdfUser } from "../../../../types/models";

/* istanbul ignore next */

export enum Columns {
  Name = "Name",
}

export const ColumnToParamMap: {
  [P in Lowercase<Columns>]: string;
} = {
  name: "firstName",
};

export const getColumnOptions = (): ColumnOption<PdfUser>[] => {
  return [
    {
      name: Columns.Name,
      width: 5,
      isSortable: true,
      disabled: (item) => item.inherited,
      render: (item) => <UserInfoCell deepLink={!item.inherited} user={item} />,
    },
  ];
};
